import { createContext, useContext, useState } from 'react'
const AuthContext = createContext(undefined)
export function useAuthContext() {
	const context = useContext(AuthContext)
	if (context === undefined) {
		throw new Error('useAuthContext must be used within an AuthProvider')
	}
	return context
}
const authSessionKey = '_SHOQA_AUTH_'
const userSessionKey = '_SHOQA_USER_'
export function AuthProvider({ children }) {
	const [user, setUser] = useState(undefined)
	const saveSession = (user) => {
		localStorage.setItem(authSessionKey, user.token);
		localStorage.setItem(userSessionKey, user.email);
		setUser(user)
	}
	const getSession = () => {
		return localStorage.getItem(authSessionKey);
	}
	const getEmail = () => {
		let name = localStorage.getItem(userSessionKey);
		return name.substring(0, name.indexOf('@'));
	}
	const removeSession = () => {
		localStorage.removeItem(authSessionKey);
		localStorage.removeItem(userSessionKey);
	}
	return (
		<AuthContext.Provider
			value={{
				user,
				isAuthenticated: getSession(),
				saveSession,
				removeSession,
				getSession,
				getEmail
			}}
		>
			{children}
		</AuthContext.Provider>
	)
}
